
<div class="main-wrapper">
  <div class="settings-section">
  <div *ngIf="showError" id="alertMessage" class="alert valign-children-middle" >
    <div class="alert-error" role="img" aria-label="Error">
      <i class="icon-badgealert"></i>
    </div>
    <div>
      <span>{{errorMessage}}</span>
    </div>
  </div>
  <div *ngIf="authenticatepage && settingsData.content && !showError">
    <div *ngIf='initModal'>
      <app-modal [showModal]="initModal" [modalClass]="modalClass">
        <app-confirm-modal [modalPopupObject]='confirmModalPopup' [triggerElement]='eventEmit' (modalOutput)="closeModal($event, confirmModalPopup.confirmButtonMessage)">
        </app-confirm-modal>
      </app-modal>
    </div>
    <section class="title-section" [ngClass]="{'have-accordion': !initialSignup && signupInputData.profileList.length>20}">
      <p *ngIf="initialSignup">{{this.settingsData.content.initialSignupDescription}}</p>
      <h2 *ngIf="initialSignup && !prodFlag">{{this.settingsData.content.heading}}</h2>
      <h2 *ngIf="prodFlag">{{this.settingsData.content.headingOem}}</h2>
      <h2 *ngIf="!initialSignup && !prodFlag">{{this.settingsData.content.revisedHeading}}</h2>
      <p *ngIf="prodFlag && initialSignup">Select your notification preference </p>
      <p *ngIf="!initialSignup && prodFlag">{{this.settingsData.content.descriptionWithModal.dropDownDescriptionOem}}</p>
      <p *ngIf="initialSignup && !prodFlag">{{this.settingsData.content.descriptionWithModal.initialSignup[0]}} 
        <a *ngIf="this.settingsData.content.descriptionWithModal.initialSignup[1]" href="javascript:void(0)" (click)="launchSupportModal()">{{this.settingsData.content.descriptionWithModal.initialSignup[1]}}</a> 
               {{this.settingsData.content.descriptionWithModal.initialSignup[2]}}
      </p>
      <div *ngIf="!initialSignup && signupInputData.profileList.length>1 && signupInputData.profileList.length<=20">
        <p *ngIf="!prodFlag">{{this.settingsData.content.descriptionWithModal.dropDownDecsription[0]}}
           <a *ngIf="this.settingsData.content.descriptionWithModal.dropDownDecsription[1]" href="javascript:void(0)" (click)="launchSupportModal()">{{this.settingsData.content.descriptionWithModal.dropDownDecsription[1]}}</a> 
                    {{this.settingsData.content.descriptionWithModal.dropDownDecsription[2]}}
        </p>
        <div *ngIf="profile.length && !prodFlag">
          <p class="dropDownLabel">{{this.settingsData.content.dropDownLabel}}</p>
          <app-dropdown [options]="profile" [placeholder]="selectedProfileName" (selectEmit)="onProfileSelect($event)"></app-dropdown>
        </div>
        <div *ngIf="profile.length && prodFlag && !initialSignup">
          <p class="dropDownLabel">{{this.settingsData.content.dropDownLabel}}</p>
          <app-dropdown [options]="profile" [placeholder]="selectedProfileName" (selectEmit)="onProfileSelect($event)"></app-dropdown>
        </div>
      </div>
      <div *ngIf="!initialSignup && signupInputData.profileList.length>20">
        <p>{{this.settingsData.content.descriptionWithModal.accordionDescription[0]}} 
          <a *ngIf="this.settingsData.content.descriptionWithModal.accordionDescription[1]" href="javascript:void(0)" (click)="getSupportContent(0)">{{this.settingsData.content.descriptionWithModal.accordionDescription[1]}}</a>
        {{this.settingsData.content.descriptionWithModal.accordionDescription[2]}}</p>
        <p>{{this.settingsData.content.selectedProfile}}: {{selectedProfileName}}
          <div class="setting-accordian">
            <app-accordion [accordion]="profiles" [accordionController]=false>
              <app-accordion-list *ngFor="let option of profiles; let i = index" [option]='option' [isSubAccordion]=true>
                <app-customgrid [gridOptions]="gridOptions[i]" (gridEvent)="gridEventChanges($event)" (radioSelections)="onProfileSelect($event)"></app-customgrid>
              </app-accordion-list>
            </app-accordion>
          </div>
      </div>
    </section>
  </div>
    <div *ngIf="formConfig.length">
      <app-form-builder [formConfig]="formConfig" [formName]="formName" (hrefLink)="launchSupportModal()" (formOutput)="getFormConfigDetails($event)"></app-form-builder>
    </div>
    <section class="buttons-section col-sm-12 col-md-12  text-right">
      <button [disabled]="showError" (click)="continueToNext()" class="btn btn-secondary pull-right">{{this.settingsData.content.buttons.continue}}</button>
      <a href="#" (click)="backToPrevious($event)" class="btn btn-link btn-block btn-cancel">{{this.settingsData.content.buttons.back}}</a>
    </section>
    <div class="accordion-section" *ngIf="!prodFlag?supportArticle:supportArticle">
      <app-accordion [accordion]="supportArticles" [accordionController]=false>
          <app-accordion-list *ngFor="let option of supportArticles; let i=index " [option]='option' [isSubAccordion]=true>
            <div class="support-content" id="player" *ngFor="let article of this.article.availableArticle; let i=index">
              <a *ngIf="!article.url" href="javascript:void(0)" title="Opens a new dialog." (click)="getSupportContent(i)" >{{article.name}}</a>
              <div *ngIf="article.url" class="mediaStop"><att-gvp  [attr.video]="article.url" ></att-gvp></div>
            </div>
        </app-accordion-list>
      </app-accordion>
    </div>
    <div *ngIf="showOverviewModal">
      <app-modal [showModal]="showOverviewModal" [modalClass]="modalClass">
        <div class="model-cover terms">
          <div class="model-box">
            <div class="modal-header">
              <div class="corner-button">
                <button class="close" aria-label="Close" (click)="closeOverviewModal()">x</button>
              </div>
              <att-gvp [attr.video]="videoId"></att-gvp>
            </div>
          </div>
        </div>
      </app-modal>
    </div>
  </div>
</div>
